import React from "react";
import { Heading, SubHeading, Container as ContainerBase } from "../section";
import tw from "twin.macro";

const dmaccUnits = [
  {
    title: "Data Management and Reporting Unit",
    director: "Sue Siminski",
    lead: ["Kayla Denson", "Kelly Dunn"]
  },
  {
    title: "Clinical Trials Auditing Unit",
    director: "Julie Chang",
    lead: ["Holly Shaw", "Barbara Wollmer"]
  },
  {
    title: "Administrative and Coordinating Unit",
    director: "KyungMann Kim",
    lead: "Kelly Miller"
  }
];

const Container = tw(ContainerBase)`max-w-5xl mx-auto`;
const Card = tw.div`mb-4 rounded border-t-4 border-red-900 bg-gray-100 p-4`;
const Grid = tw.div`md:grid grid-cols-3 gap-6`;

const About = () => (
  <Container>
    <Heading>
      The DMACC is composed of <strong>three operational units</strong>.
    </Heading>
    <Grid>
      {dmaccUnits.map((unit, i) => (
        <Card key={`unit-${i}`}>
          <SubHeading>{unit.title}</SubHeading>
          <p>Director: {unit.director}</p>
          {Array.isArray(unit.lead) ? (
            <p>Leads: {unit.lead.join(", ")}</p>
          ) : (
            <p>Lead: {unit.lead}</p>
          )}
        </Card>
      ))}
    </Grid>
  </Container>
);

export default About;
